<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-search">
      <el-row type="flex" justify="space-between">
        <el-form :inline="true" :model="search">
          <el-form-item label="类型">
            <Select key="1" :selected.sync="search.testing_id" :data="typeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="fnGetLists()">查询</el-button>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="fnCreateProject()">添加</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
    <div class="tuolele-main-content">
      <el-table :data="tableData" border stripe>
        <el-table-column prop="testing_name" label="分类" />
        <el-table-column prop="project_content" label="检查项目" />
        <el-table-column prop="" label="选项">
          <template slot-scope="scope">
            <p v-for="item in scope.row.project_info">{{ item.name }}({{ item.desc }}):{{ item.num }}分</p>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="fnEditProject(scope.row)">编辑</el-button>
            <el-button type="danger" @click="fnDelete(scope.row.project_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="新增项目" :visible.sync="dialogVisible" width="600px">
        <el-form :model="postForm">
          <el-form-item label="所属分类">
            <Select key="999999" :selected.sync="postForm.testing_id" :data="typeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="postForm.project_content" style="width: 400px;" placeholder="请输入内容" />
          </el-form-item>
          <el-form-item label="评分项" />
          <div v-for="(item,index) in postForm.project_lists" :key="'pl_' + index" class="wq_flex" style="margin-bottom: 10px;">
            <el-input v-model="postForm.project_lists[index].name" style="width: 150px;margin-right: 10px;" placeholder="名称" />
            <el-input v-model="postForm.project_lists[index].desc" style="width: 150px;margin-right: 10px;" placeholder="备注说明" />
            <Select style="width: 150px;margin-right: 10px;" :selected.sync="postForm.project_lists[index].is_photo" :data="photoSelect" />
            <el-input-number v-model="postForm.project_lists[index].num" style="width: 180px;margin-right: 10px;" :min="-100" :max="100" label="分值" />
            <el-button type="text" @click="fnDeleteQualityItem(index)">删除</el-button>
          </div>
          <el-button type="text" @click="fnAddQualityItem()">添加一条</el-button>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="fnSubmit">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Select from '@/components/Select'
import Tool from '@/assets/js/tool.js'

const defaultPostForm = {
  testing_id: '',
  project_content: '',
  project_info: '',
  project_id: '',
  project_lists: []
}

export default {
  name: 'StoreSetting',
  components: {
    Select
  },
  data() {
    return {
      dialogVisible: false,
      search: {
        testing_id: ''
      },
      postForm: Object.assign({}, defaultPostForm),
      typeLists: [],
      tableData: [],
      photoSelect: [{
        id: 1,
        name: '无需拍照'
      },
      {
        id: 2,
        name: '需拍照'
      }]
    }
  },
  mounted() {
    this.fnGetLists()
  },
  methods: {
    fnGetLists() {
      this.$http.getProjectList(this.search).then(res => {
        this.tableData = res.data.project_list;
        (res.data.type_list || []).forEach((ele) => {
          ele.id = ele.testing_id
          ele.name = ele.testing_name
        })
        this.typeLists = res.data.type_list
      })
    },
    fnDelete(project_id) {
      this.$confirm('是否删除质检项目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delProject({ project_id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetLists()
        })
      })
    },
    fnCreateProject(projectId) {
      this.postForm = Object.assign({}, defaultPostForm)
      this.dialogVisible = true
    },
    fnDeleteQualityItem(index) {
      this.postForm.project_lists.splice(index, 1)
    },
    fnAddQualityItem() {
      this.postForm.project_lists.push({ name: '', desc: '', is_photo: 2, num: 0 })
    },
    fnEditProject(project) {
      this.postForm.project_id = project.project_id
      this.postForm.project_lists = project.project_info
      this.postForm.project_content = project.project_content
      this.postForm.testing_id = project.testing_id
      this.dialogVisible = true
    },
    fnSubmit() {
      if (this.postForm.testing_id === '') {
        this.$message.error('请选择所属分类')
        return
      }
      if (this.postForm.project_content === '') {
        this.$message.error('请填写项目名称')
        return
      }
      if (this.postForm.project_lists.length === 0) {
        this.$message.error('没有评分项目')
        return
      }
      if (this.checkNameEmpty()) {
        this.$message.error('请填写名称')
        return
      }
      this.postForm.project_info = JSON.stringify(this.postForm.project_lists)
      this.$http.editProject(this.postForm)
        .then(() => {
          this.$message({
            type: 'success',
            message: '配置分组成功'
          })
          this.dialogVisible = false
          this.fnGetLists()
        })
    },
    checkNameEmpty() {
      return Tool.findIndexInArryByKeyVal(this.postForm.project_lists, 'name', '') > -1
    }

  }
}
</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
}
</style>
